import { render } from "./NurseCallsHistory.vue?vue&type=template&id=8b3d02f2&scoped=true"
import script from "./NurseCallsHistory.vue?vue&type=script&lang=js"
export * from "./NurseCallsHistory.vue?vue&type=script&lang=js"

import "./NurseCallsHistory.vue?vue&type=style&index=0&id=8b3d02f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3d02f2"]])

export default __exports__